<div class="modal-header">
    <h5 class="modal-title">Adjust Score - Question No: {{questionNo}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <div class="score-info mb-1">
        <span class="badge bg-secondary p-2 fw-bold">Marks Obtainable: {{maxScore}}</span>
    </div>
    <form [formGroup]="adjustmentForm">
        <div class="mb-3">
            <label for="currentScore" class="form-label">Current Score:</label>
            <input type="number" min="0" class="form-control" id="currentScore" [value]="currentScore" disabled>
        </div>
        <div *ngIf="!hasessaysubquestions && examinationType !== 'SAQ'" class="mb-3">
            <label for="adjustedScore" class="form-label">Enter Adjusted Score:</label>
            <input type="number" min="0" class="form-control" id="adjustedScore" formControlName="adjustedScore">
            <div *ngIf="adjustedScore.invalid && (adjustedScore.dirty || adjustedScore.touched)" class="text-danger">
                <div *ngIf="adjustedScore.errors?.required">Score is required.</div>
                <div *ngIf="adjustedScore.errors?.max">Score cannot exceed {{maxScore}}.</div>
            </div>
        </div>

        <!-- SAQ Marking -->
        <div *ngIf="examinationType === 'SAQ'" class="mb-3">
            <label for="markingStatus" class="form-label">Marking Status:</label>
            <ng-select class="form-select" id="markingStatus" formControlName="markingStatus">
                <ng-option value="correct"
                    [disabled]="answerStatusString.toLowerCase() === 'correct'">Correct</ng-option>
                <ng-option value="incorrect"
                    [disabled]="answerStatusString.toLowerCase()  === 'incorrect'">Incorrect</ng-option>
            </ng-select>
            <div *ngIf="markingStatus.invalid && (markingStatus.dirty || markingStatus.touched)" class="text-danger">
                <div *ngIf="markingStatus.errors?.required">Marking status is required.</div>
            </div>
        </div>

        <div *ngIf="hasessaysubquestions" class="mb-2">
            <h5>Essay Sub-Question Scores</h5>

            <!-- Essay Sub-Question Adjustment -->
            <div formArrayName="essaySubQuestionScores">
                <!-- Header Row -->
                <div class="row py-2 fw-bold align-items-center bg-light rounded mb-2">
                    <div class="col-md-2 text-center">Q.No</div>
                    <div class="col-md-4 text-center">Current Score</div>
                    <div class="col-md-6 text-center">New Score</div>
                </div>

                <!-- Sub-Question Rows -->
                <div *ngFor="let eSubQuestion of essaySubQuestionScores.controls; let i = index" class="card mb-3"
                    [formGroupName]="i">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <!-- Sub-Question Label -->
                            <div class="col-md-2">
                                <div class="fw-bold text-primary">
                                    {{questionNo}}{{eSubQuestion.get('questionNoLabel').value}}
                                </div>
                            </div>

                            <!-- Current Score (Read-only) -->
                            <div class="col-md-4">
                                <input type="number" min="0" class="form-control bg-light"
                                    [value]="eSubQuestion.get('currentScore').value" disabled>
                            </div>

                            <!-- New Score Input -->
                            <div class="col-md-6">
                                <div class="input-group flex-nowrap">
                                    <input type="number" min="0" class="form-control" formControlName="newScore"
                                        [max]="eSubQuestion.get('maxMarks').value" step="0.5" placeholder="New score"
                                        [ngClass]="{'is-invalid': eSubQuestion.get('newScore').invalid && eSubQuestion.get('newScore').touched}" />
                                    <span class="input-group-text">/{{eSubQuestion.get('maxMarks').value}}</span>
                                </div>
                                <div *ngIf="eSubQuestion.get('newScore').invalid && eSubQuestion.get('newScore').touched"
                                    class="text-danger small mt-1">
                                    <span *ngIf="eSubQuestion.get('newScore').errors?.required">Score required</span>
                                    <span *ngIf="eSubQuestion.get('newScore').errors?.max">Exceeds maximum
                                        ({{eSubQuestion.get('maxMarks').value}})</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Total Section Score -->
            <div class="alert alert-info py-1 px-2 my-2 small"
                [ngClass]="{'alert-danger': totalSubQuestionScore > maxScore}">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="fw-bold">Total Score:</span>
                    <span>{{totalSubQuestionScore}} / {{maxScore}}</span>
                </div>
                <div *ngIf="totalSubQuestionScore > maxScore" class="text-danger mt-1">
                    Total scores exceed the maximum mark!
                </div>
            </div>
        </div>
        <!-- Adjustment Reason -->
        <div class="mb-1">
            <label for="adjustmentReason" class="form-label">Reason for Adjustment: </label>
            <textarea class="form-control" id="adjustmentReason" rows="2" formControlName="adjustmentReason"
                placeholder="Provide reason for score adjustment..."></textarea>
            <div *ngIf="adjustmentReason.invalid && (adjustmentReason.dirty || adjustmentReason.touched)"
                class="text-danger">
                <div *ngIf="adjustmentReason.errors?.required">Reason is required.</div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()"
        [disabled]="adjustmentForm.invalid || (hasessaysubquestions && totalSubQuestionScore > maxScore)">Apply
        Adjustment</button>
</div>